import { render, staticRenderFns } from "./ModalIdle.vue?vue&type=template&id=af1600b0&scoped=true&"
import script from "./ModalIdle.vue?vue&type=script&lang=js&"
export * from "./ModalIdle.vue?vue&type=script&lang=js&"
import style0 from "./ModalIdle.vue?vue&type=style&index=0&id=af1600b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1600b0",
  null
  
)

export default component.exports